/**
 * Thinking mode presets for Care Delivery AI chat turns.
 *
 * Configures the reasoning token budget and user guidance for Gemini 3.8 Flash:
 * - Fast: budget=0 (instant TTFT < 2s for routine Q&A, medications, screeners).
 * - Balanced: budget=1024 (3–5s TTFT for trajectory comparisons and trend synthesis).
 * - Deep: budget=4096 (10–15s TTFT for complex differential diagnosis and contradictions).
 */

export type ThinkingMode = "fast" | "balanced" | "deep";

export interface ThinkingModeOption {
  id: ThinkingMode;
  label: string;
  budget: number;
  ttft: string;
  tooltip: string;
}

export const THINKING_MODES: readonly ThinkingModeOption[] = [
  {
    id: "fast",
    label: "Fast",
    budget: 0,
    ttft: "<2s",
    tooltip:
      "Instant TTFT (<2s). Best for medication lookups, screener scores, visit summaries, routine Q&A.",
  },
  {
    id: "balanced",
    label: "Balanced",
    budget: 1024,
    ttft: "3–5s",
    tooltip:
      "3–5s TTFT. Best for longitudinal trajectory comparison and multi-encounter trend synthesis.",
  },
  {
    id: "deep",
    label: "Deep",
    budget: 4096,
    ttft: "10–15s",
    tooltip:
      "10–15s TTFT. Best for complex differential diagnosis, contradictory Vanderbilt analysis, and multi-variable somatic/pharmacotherapy contraindications.",
  },
] as const;
